
import store from "../store";
import * as types from "./constants";
import { getPhotoPosts } from "../photos/actions";
import * as utils from "../utils";
import { modal_ajax_error_handler } from '../../common/modal/_ajax_error_handler';

export function postFeedComment(comment, tags=[], mentions=[], captcha=null) {
  const postData = {
    comment,
    captcha,
    tags: JSON.stringify(tags),
    mentions: JSON.stringify(mentions)
  };
  const url = `/ajax/event/${window.evite_event.id}/posts/comments/?gid=${window.guest_id}`;
  window.$.post(url, postData, (response) => {
    response.user_submitted = true;
    store.dispatch({
      type: types.ADD_FEED_POST,
      post: response
    });
    window.dataLayer.push({'event': 'comment'});
  })
  .fail((xhr, status, data) => {
    if (xhr.status === 412) {
      utils.handleCaptcha(xhr, status, data, function (captcha) {
        postFeedComment(comment, tags, mentions, captcha);
      });
    } else {
      modal_ajax_error_handler(xhr, status, data);
    }
  });
}

export function hydrateFeedPosts(cursor='') {
  const url = urls.get('ajax_event_posts', {
    event_id: window.evite_event.id,
    gid: window.guest_id,
    cursor
  });
  $.get(url, (response) => {
    store.dispatch({
      type: types.ADD_FEED_POSTS,
      objects: response.objects,
      cursor: response.cursor,
      more: response.more
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}


export function getFeedPosts(cursor='') {
  const url = urls.get('ajax_event_posts', {
    event_id: window.evite_event.id,
    gid: window.guest_id,
    cursor
  });
  window.$.get(url, (response) => {
    store.dispatch({
      type: types.ADD_FEED_POSTS,
      objects: response.objects,
      cursor: response.cursor,
      more: response.more
    });
    window.dataLayer.push({'event': 'show_more_feed_posts'});
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  // This is less than ideal, but here we grab more photos for the gallery
  // whenever we grab more for the activity feed to ensure that we have the
  // photo in the photo state...
  getPhotoPosts();
}

export function setSinglePostModalVisible(visible) {
  store.dispatch({
    type: types.SET_SINGLE_POST_MODAL_VISIBLE,
    visible
  })
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/activity-feed/actions.es6